import React from "react";
import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import Rating from "../components/Rating";
import { useCart } from "../context/CartContext";
import { useWishlist } from "../context/WishlistContext";

export default function ProductCard({ product }) {
    const { addToCart } = useCart();
    const { has, toggle } = useWishlist();
    const wished = has(product.id);
    const discount = product.original_price
        ? Math.round(((product.original_price - product.price) / product.original_price) * 100)
        : 0;

    return (
        <div
            data-testid={`product-card-${product.slug}`}
            className="group bg-white border border-brand-line rounded-2xl overflow-hidden transition-all duration-300 hover:shadow-xl hover:-translate-y-1"
        >
            <Link to={`/products/${product.slug}`} className="block">
                <div className="relative bg-brand-sand aspect-square overflow-hidden">
                    <img
                        src={product.images?.[0]}
                        alt={product.name}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                    {discount > 0 && (
                        <span className="absolute top-3 left-3 bg-brand-orange text-white text-xs font-black px-2.5 py-1 rounded-lg">
                            -{discount}%
                        </span>
                    )}
                    <button
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            toggle(product);
                        }}
                        data-testid={`wishlist-toggle-${product.slug}`}
                        className="absolute top-3 right-3 w-9 h-9 rounded-full bg-white/90 backdrop-blur flex items-center justify-center hover:bg-white transition"
                        aria-label="Toggle wishlist"
                    >
                        <Heart
                            size={16}
                            strokeWidth={2.5}
                            className={wished ? "fill-brand-orange text-brand-orange" : "text-brand-ink"}
                        />
                    </button>
                </div>
            </Link>

            <div className="p-5">
                <div className="flex items-center justify-between text-[11px] uppercase tracking-wider text-brand-moss font-bold mb-1.5">
                    <span>{product.pack_size}</span>
                    <Rating value={product.rating} count={product.reviews_count} />
                </div>
                <Link to={`/products/${product.slug}`}>
                    <h3 className="font-heading font-bold text-lg leading-tight text-brand-ink hover:text-brand-orange transition">
                        {product.name}
                    </h3>
                </Link>
                <div className="flex items-end gap-2 mt-2">
                    <span className="font-heading font-black text-2xl text-brand-ink">₹{product.price}</span>
                    {product.original_price && (
                        <span className="text-sm line-through text-brand-moss mb-0.5">₹{product.original_price}</span>
                    )}
                </div>
                <button
                    onClick={() => addToCart(product)}
                    data-testid={`add-to-cart-${product.slug}`}
                    className="w-full mt-4 bg-brand-ink text-white font-bold py-3 rounded-xl hover:bg-brand-orange transition-colors text-sm"
                >
                    Add to Cart
                </button>
            </div>
        </div>
    );
}
